module.exports = __webpack_public_path__ + "static/media/Professor Frink.c9877e69.png";